<template>
  <div id="app" class="container-fluid px-0" v-cloak @drop.prevent @dragover.prevent>
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup lang="ts">
import('@/classes/PdfjsLib').then(lib => lib.default());
</script>

<style>
</style>
